// import { useEffect, useState } from "react";

// import Cookies from "js-cookie";


// // Reusable Circular Progress Component
// function CircularProgress({ value, max, label, color }) {
//   const radius = 50;
//   const strokeWidth = 8;
//   const circumference = 2 * Math.PI * radius;
//   const progress = (value / max) * circumference;

//   return (
//     <div className="tc">
//       <svg width="120" height="120" className="mb3">
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke="#e5e7eb" // gray background
//           strokeWidth={strokeWidth}
//           fill="none"
//         />
//         <circle
//           cx="60"
//           cy="60"
//           r={radius}
//           stroke={color}
//           strokeWidth={strokeWidth}
//           fill="none"
//           strokeDasharray={circumference}
//           strokeDashoffset={circumference - progress}
//           strokeLinecap="round"
//           transform="rotate(-90 60 60)"
//         />
//         <text
//           x="60"
//           y="65"
//           textAnchor="middle"
//           className="f4 fw6 dark-gray"
//         >
//           {value}
//         </text>
//       </svg>
//       <div className="f6 gray">{label}</div>
//     </div>
//   );
// }

// export default function RecordsDashboard() {
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);


//   useEffect(() => {
//     //fetch agents
//     const fetchAll = () => {
//       let adminCookie = Cookies.get("sessioniduser");
//       if (adminCookie.length >= 1) {
//         setLoading(true);

//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/getRecords", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               userid: adminCookie,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error("Wrong credentials");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//             .then((user) => {
//               if (user[0].id >= 1) {
//                 //load data



//                 //new way to update the state event without duplicates
//                 // Update events using setEvents, excluding duplicates
               
//                 setRecords(user);
//         setLoading(false);
//               } else {
//                 //dont load

              
//                 setLoading(null);
//               }
//             })
//             .catch((err) => {
//               // setFoundErr(err.message);
//               setLoading(null);
//               // setFlag(1);
//             });
//         }, 2000);
//       } else {
//         setLoading(null);
//       }
//     };

//     fetchAll();
//   }, []);

//   const totalRecords = records.length;
// //   const totalWeight = records.reduce((sum, r) => sum + (r.weight || 0), 0);

// // ✅ Safely sum weights, converting string -> number
// const totalWeight = records.reduce(
//   (sum, r) => sum + (parseFloat(r.weight) || 0),
//   0
// ).toFixed(2); // Keep two decimal places

// // ✅ Dynamic max for progress bar: take the highest value + buffer
// const weightMax = totalWeight > 0 ? totalWeight * 1.2 : 100; 
// const recordsMax = totalRecords > 0 ? totalRecords * 1.2 : 100;

//   // if (loading) return <div className="pa4 gray">Loading...</div>;

//   return (
//     <div className="pa0">
//       {/* Progress Circles */}
//       <div className="flex flex-wrap justify-center gap4">
//   <CircularProgress
//     value={totalRecords}
//     max={recordsMax}
//     label="Total Records"
//     color="#3b82f6" // blue
//   />
//   <CircularProgress
//     value={totalWeight}
//     max={weightMax}
//     label="Total Weight (kg)"
//     color="#10b981" // green
//   />
// </div>


    
//     </div>
//   );
// }


// new with icon
import { useEffect, useState } from "react";
import Cookies from "js-cookie";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
 YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

// =====================
// Circular Progress
// =====================
function CircularProgress({ value, max, label, color }) {
  const radius = 50;
  const strokeWidth = 8;
  const circumference = 2 * Math.PI * radius;
  const progress = max > 0 ? (value / max) * circumference : 0;

  return (
    <div className="tc">
      <svg width="120" height="120" className="mb3">
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          transform="rotate(-90 60 60)"
        />
        <text
          x="60"
          y="65"
          textAnchor="middle"
          className="f4 fw6 dark-gray"
        >
          {value}
        </text>
      </svg>
      <div className="f6 gray">{label}</div>
    </div>
  );
}

// =====================
// Dashboard
// =====================
export default function RecordsDashboard() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    fetchDashboard();
  }, []);

const fetchDashboard = async () => {
  try {
    const userid = Cookies.get("sessioniduser") || "";

    if (!userid) {
      setLoading(false);
      return;
    }

    const res = await fetch(
      "https://api.terraweb.africa/getRecords",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userid }),
      }
    );

    const data = await res.json();

    // safety check (important)
    if (data?.profile) {
      setProfile(data.profile || {});
      setRecords(data.records || []);
    } else {
      // fallback for unexpected response
      setProfile({});
      setRecords([]);
    }

    setLoading(false);
  } catch (err) {
    console.error(err);
    setLoading(false);
  }
};

  // =====================
  // DATE FILTER HELPERS
  // =====================
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();

  const isThisMonth = (dateStr) => {
    const d = new Date(dateStr);
    return (
      d.getMonth() === currentMonth &&
      d.getFullYear() === currentYear
    );
  };

  // =====================
  // METRICS
  // =====================
  const totalRecords = records.length;

  const monthlyRecords = records.filter((r) =>
    isThisMonth(r.daterecorded)
  ).length;

  const approvedRecords = records.filter(
    (r) => r.approved_status === "approved"
  ).length;

  const totalWeight = records
    .reduce(
      (sum, r) =>
        sum + (parseFloat(r.weight) || 0),
      0
    )
    .toFixed(2);

  // dynamic max scaling
  const recordsMax =
    totalRecords > 0
      ? totalRecords * 1.2
      : 100;

  const monthlyMax =
    monthlyRecords > 0
      ? monthlyRecords * 1.2
      : 50;

  const approvedMax =
    totalRecords > 0
      ? totalRecords
      : 100;

  const weightMax =
    totalWeight > 0
      ? totalWeight * 1.2
      : 100;
const getGenderAvatar = (gender) => {
  switch (gender) {
    case "female":
      return "/img/femaleavatar.jpg";
    case "male":
      return "/img/maleavatar.jpeg";
    default:
      return "/img/maleavatar.png";
  }
};

const grouped = {};

records.forEach((r) => {
  const day = new Date(r.daterecorded).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });

  if (!grouped[day]) {
    grouped[day] = {
      date: day,
      milk: 0,
      coffee: 0,
      tea: 0,
    };
  }

  const weight = Number(r.weight);

  switch (r.producttype.toLowerCase()) {
    case "milk":
      grouped[day].milk += weight;
      break;

    case "coffee":
      grouped[day].coffee += weight;
      break;

    case "tea leaves":
      grouped[day].tea += weight;
      break;
  }
});

const chartData = Object.values(grouped);

const milkTotal = records
  .filter(r => r.producttype === "milk")
  .reduce((s, r) => s + Number(r.weight), 0);

const coffeeTotal = records
  .filter(r => r.producttype === "coffee")
  .reduce((s, r) => s + Number(r.weight), 0);

const teaTotal = records
  .filter(r => r.producttype === "tea leaves")
  .reduce((s, r) => s + Number(r.weight), 0);

  if (loading) {
    return (
      <div className="pa4 tc gray">
        Loading dashboard...
      </div>
    );
  }

  return (
    <div className="pa3">

      {/* =====================
          USER HEADER
      ===================== */}
      <div className="flex items-center mb4">

        {/* ICON */}
    <div
  style={{
    width: 60,
    height: 60,
    borderRadius: "50%",
    overflow: "hidden",
    marginRight: 12,
    border: "2px solid #fc9c1c",
  }}
>
  <img
    src={getGenderAvatar(profile?.gender)}
    alt="user avatar"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
    }}
  />
</div>

        {/* USER INFO */}
        <div>
          <div className="f4 b">
            {profile?.username || "User"}
          </div>
          <div className="gray f6">
            {profile?.company || "Company"}
          </div>
        </div>
      </div>

      {/* =====================
          METRICS
      ===================== */}
      {/* <div className="flex flex-wrap justify-center gap4">

        <CircularProgress
          value={totalRecords}
          max={recordsMax}
          label="All Records"
          color="#3b82f6"
        />

        <CircularProgress
          value={monthlyRecords}
          max={monthlyMax}
          label="This Month"
          color="#f59e0b"
        />

        <CircularProgress
          value={approvedRecords}
          max={approvedMax}
          label="Approved"
          color="#10b981"
        />

        <CircularProgress
          value={Number(totalWeight)}
          max={weightMax}
          label="Total Weight"
          color="#8b5cf6"
        />
      </div> */}

      <>
    <h3 className="tc mb3">
        Daily Production Trend
    </h3>

    <ResponsiveContainer
        width="100%"
        height={320}
    >

        <LineChart data={chartData}>

            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="date" />

            <YAxis domain={[0, "auto"]} />

            <Tooltip />

            <Legend />

            <Line
                type="monotone"
                dataKey="milk"
                stroke="#2563eb"
                strokeWidth={4}
                dot={false}
            />

            <Line
                type="monotone"
                dataKey="coffee"
                stroke="#ef4444"
                strokeWidth={4}
                dot={false}
            />

            <Line
                type="monotone"
                dataKey="tea"
                stroke="#22c55e"
                strokeWidth={4}
                dot={false}
            />

        </LineChart>

    </ResponsiveContainer>

    <div className="flex justify-center flex-wrap mt4">

        <div className="pa3">
            <span style={{color:"#2563eb"}}>■</span>
            {" "}Milk ({milkTotal} kg)
        </div>

        <div className="pa3">
            <span style={{color:"#ef4444"}}>■</span>
            {" "}Coffee ({coffeeTotal} kg)
        </div>

        <div className="pa3">
            <span style={{color:"#22c55e"}}>■</span>
            {" "}Tea Leaves ({teaTotal} kg)
        </div>

        

        <div className="pa3">
            {/* <span style={{color:"#bd7e00"}}>■</span> */}
            {" "} All <b>
              ({totalRecords})
              </b> 
        </div>
        
        <div className="pa3">
            {/* <span style={{color:"#7800b4"}}>■</span> */}
            {" "}Approved <b>
              ({approvedRecords})
              </b>
        </div>
     

    </div>
</>
    </div>
  );
}